// contributors-b
//
// Purpose: Community contributor preset categories (B)
//
// This module:
// - Exports preset categories: Treethletress through Jayden256

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const contributorCategoriesB: InputPresetCategory[] = [
	{
		name: "Treethletress's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Shrill Arcade Saw",
				generalMidi: false,
				tags: ["chip", "chipwave", "treethletress"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"ring modulation",
						"granular",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -88,
					vibrato: "custom",
					vibratoDepth: 0.28,
					vibratoDelay: 23,
					vibratoSpeed: 7,
					vibratoType: 0,
					granular: 2,
					grainSize: 32,
					grainAmounts: 9,
					grainRange: 40,
					ringMod: 29,
					ringModHz: 25,
					rmWaveformIndex: 0,
					rmPulseWidth: 0,
					rmHzOffset: 48,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					unison: "dirty",
					wave: "modbox curved sawtooth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "ringModulationHz", envelope: "twang 1" },
						{
							target: "granular",
							envelope: "flutter 2",
						},
						{ target: "detune", envelope: "tripolo1" },
					],
				},
			},
			{
				name: "Bit Banjo",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress", "featured"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 1,
					pitchShiftSemitones: 12,
					detuneCents: 24,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 43,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3←4)",
					feedbackType: "2⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "4×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
					],
				},
			},
			{
				name: "Crusher Synth",
				generalMidi: false,
				tags: ["supersaw", "treethletress"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					detuneCents: 36,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 0,
					echoSustain: 86,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [
						{ target: "detune", envelope: "flute 2" },
						{
							target: "pitchShift",
							envelope: "blip 3",
						},
					],
				},
			},
			{
				name: "Funky Bass Synth",
				generalMidi: false,
				tags: ["chip", "chipwave", "treethletress"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"chorus",
						"echo",
					],
					transition: "slide",
					clicklessTransition: false,
					slideTicks: 14,
					pitchShiftSemitones: 12,
					detuneCents: 28,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1 }],
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "none",
					wave: "sawtooth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterFreq", envelope: "flare 1", index: 0 }],
				},
			},
			{
				name: "Twangy Synth Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "treethletress"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "detune", "bitcrusher"],
					pitchShiftSemitones: 0,
					detuneCents: 36,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "twang 2", index: 1 }],
				},
			},
			{
				name: "Synth Guitar",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					detuneCents: 36,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 0,
					echoSustain: 86,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "detune", envelope: "flute 2" },
						{
							target: "pitchShift",
							envelope: "blip 3",
						},
					],
				},
			},
			{
				name: "Glitched Shimmer",
				generalMidi: false,
				tags: ["chip", "chipwave", "treethletress"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "detune", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					detuneCents: 32,
					panDelay: 10,
					echoSustain: 86,
					echoDelayBeats: 1.333,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					unison: "none",
					wave: "glitch",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 224,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Orchid25 Ethereal Vox",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					detuneCents: 36,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 0,
					echoSustain: 86,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "detune", envelope: "flute 2" },
						{
							target: "pitchShift",
							envelope: "blip 3",
						},
					],
				},
			},
			{
				name: "Zunpet & Keys",
				generalMidi: false,
				tags: ["fm", "fm6op", "treethletress"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "detune"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: -80,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2(3(4(5(6",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 2", index: 1 },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
						{ target: "detune", envelope: "pentolo1" },
					],
				},
			},
			{
				name: "Slidophone",
				generalMidi: false,
				tags: ["chip", "chipwave", "treethletress"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2 },
					],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"vibrato",
						"note filter",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: true,
					slideTicks: 48,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					detuneCents: 24,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					panDelay: 10,
					chorus: 57,
					reverb: 42,
					fadeInSeconds: 0.0575,
					fadeOutTicks: -6,
					unison: "none",
					wave: "square",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "punch" }],
				},
			},
			{
				name: "FM Crunchy Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["detune", "vibrato", "distortion", "bitcrusher"],
					detuneCents: -80,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 2", index: 1 },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
						{ target: "detune", envelope: "pentolo1" },
					],
				},
			},
			{
				name: "Crunchy Wasp",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "chord type", "detune", "vibrato", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: -84,
					vibrato: "custom",
					vibratoDepth: 0.64,
					vibratoDelay: 10,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 1.4142,
						},
					],
					panDelay: 10,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 3 },
						{ target: "detune", envelope: "pentolo1" },
						{ target: "feedbackAmplitude", envelope: "wibble-1" },
					],
				},
			},
			{
				name: "Squeaky Synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 1512.61, linearGain: 1 }],
					eqFilterType: true,
					eqSimpleCut: 5,
					eqSimplePeak: 2,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["transition type", "vibrato", "chorus"],
					transition: "slide",
					clicklessTransition: false,
					slideTicks: 48,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Hyper Shredder Guitar",
				generalMidi: false,
				tags: ["pwm", "treethletress"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 8 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 2 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 8 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 2 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
					],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 4,
					detuneCents: 68,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 6,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 500, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 353.55, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 500, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 353.55, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.0884 },
					],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					unison: "hecking gosh",
					pulseWidth: 50,
					decimalOffset: 0,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "rise -2", index: 2 },
						{ target: "noteFilterFreq", envelope: "swell 3", index: 2 },
						{ target: "noteFilterFreq", envelope: "punch", index: 1 },
						{ target: "noteFilterFreq", envelope: "twang 1", index: 3 },
					],
				},
			},
			{
				name: "Burning Strings",
				generalMidi: false,
				tags: ["chip", "chipwave", "treethletress"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
						"granular",
					],
					transition: "slide",
					clicklessTransition: false,
					slideTicks: 3,
					pitchShiftSemitones: 24,
					detuneCents: 80,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1,
						},
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1,
						},
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
					],
					granular: 4,
					grainSize: 13,
					grainAmounts: 2,
					grainRange: 10,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 100,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "octave",
					wave: "modbox sax",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 5,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "pitchShift", envelope: "twang -1" }],
				},
			},
			{
				name: "Digaccordian",
				generalMidi: false,
				tags: ["chip", "chipwave", "treethletress", "featured"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: true,
					pitchShiftSemitones: 12,
					detuneCents: 80,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					distortion: 86,
					aliases: false,
					panDelay: 10,
					chorus: 29,
					reverb: 16,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					unison: "octave",
					wave: "todbox accordian",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 115,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{ target: "detune", envelope: "pentolo4" },
						{ target: "distortion", envelope: "swell -1" },
						{ target: "distortion", envelope: "tremolo5" },
						{ target: "detune", envelope: "swell -1" },
						{ target: "chorus", envelope: "wibble 3" },
						{ target: "chorus", envelope: "flare 3" },
					],
				},
			},
			{
				name: "Flute Synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "treethletress"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: [
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: -36,
					vibrato: "custom",
					vibratoDepth: 0.4,
					vibratoDelay: 19,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 707.11, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 707.11, linearGain: 0.1768 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 0,
					echoSustain: 43,
					echoDelayBeats: 0.417,
					reverb: 13,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 6,
					algorithm: "1 2←3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "swell 1", index: 3 },
						{ target: "feedbackAmplitude", envelope: "twang 3" },
						{ target: "operatorAmplitude", envelope: "tremolo6", index: 0 },
						{ target: "noteFilterFreq", envelope: "pentolo1", index: 0 },
						{ target: "distortion", envelope: "tremolo1" },
					],
				},
			},
			{
				name: "Crunchy Snare",
				generalMidi: false,
				tags: ["noise", "treethletress", "snare"],
				settings: {
					type: "noise",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"bitcrusher",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 0,
					detuneCents: -84,
					vibrato: "custom",
					vibratoDepth: 0.64,
					vibratoDelay: 10,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 5.6569 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 5.6569 },
					],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 14,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "hollow",
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "detune",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Crusher Taiko",
				generalMidi: false,
				tags: ["noise", "treethletress"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 3222.02, linearGain: 1 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 2,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [
						"pitch shift",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 14,
					echoSustain: 71,
					echoDelayBeats: 1.25,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					unison: "none",
					wave: "static",
					envelopes: [{ target: "noteFilterFreq", envelope: "twang -1", index: 0 }],
				},
			},
			// { name: "", generalMidi: false, tags:["", "treethletress"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "treethletress"], settings: {} },

			// { name: "", generalMidi: false, tags:["", "treethletress"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "treethletress"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "treethletress"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "treethletress"], settings: {} },
		]),
	},
	{
		name: "literally_luigi_irl's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.0--------------
			{
				name: "Expresso Bass",
				generalMidi: false,
				tags: ["harmonics", "literally_luigi_irl", "picked"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					eqSubFilters1: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 }],
					effects: ["chord type", "pitch shift", "vibrato", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 1,
					pitchShiftSemitones: 12,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						100, 100, 100, 100, 86, 71, 57, 29, 29, 43, 43, 57, 71, 57, 29, 29, 43, 57,
						57, 57, 43, 43, 43, 57, 71, 71, 71, 71,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 1" }],
				},
			},
			{
				name: "Expresso Slap",
				generalMidi: false,
				tags: ["pickedstring", "literally_luigi_irl", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 }],
					eqSubFilters1: [],
					effects: ["chord type", "vibrato", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 1,
					vibrato: "custom",
					vibratoDepth: 0.16,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 86, 71, 71, 71, 86, 86, 71, 57, 43, 43, 43, 57, 57, 57, 57, 57,
						43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
					],
					unison: "none",
					stringSustain: 64,
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.3--------------
			{
				name: "Wave Of Light",
				generalMidi: false,
				tags: ["pwm", "literally_luigi_irl", "retro", "distortion"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					effects: ["vibrato", "distortion", "echo"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 100,
					aliases: false,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.167,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "warbled",
					envelopes: [],
				},
			},
			{
				name: "Spacey Harmonics",
				generalMidi: false,
				tags: ["harmonics", "literally_luigi_irl", "novelty", "distortion"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["detune", "note filter", "distortion", "chorus", "echo", "reverb"],
					detuneCents: -25,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 11.3137 }],
					distortion: 71,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 61,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					harmonics: [
						100, 86, 29, 29, 14, 14, 0, 14, 14, 43, 71, 100, 100, 86, 71, 71, 57, 57,
						43, 43, 43, 43, 43, 0, 0, 0, 0, 0,
					],
					unison: "octave",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Grainy Saw",
				generalMidi: false,
				tags: ["supersaw", "literally_luigi_irl", "retro", "distortion", "novelty"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"vibrato",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: -25,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 71,
					aliases: false,
					panDelay: 0,
					chorus: 71,
					reverb: 35,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 24,
					pulseWidth: 28,
					decimalOffset: 47,
					dynamism: 33,
					spread: 100,
					shape: 100,
					envelopes: [],
				},
			},
			{
				name: "Granular Space FM",
				generalMidi: false,
				tags: ["fm", "fm4op", "literally_luigi_irl", "retro", "guitar"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["vibrato", "granular", "chorus", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 4,
					grainSize: 50,
					grainAmounts: 3,
					grainRange: 15,
					panDelay: 0,
					chorus: 57,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 (3 (4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 11, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Creepy Pasta",
				generalMidi: false,
				tags: ["chip", "chipwave", "literally_luigi_irl", "retro", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "vibrato", "distortion", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -20,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 86,
					aliases: false,
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "bow",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Crisp FM",
				generalMidi: false,
				tags: ["fm", "fm6op", "literally_luigi_irl", "retro", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←(4 5 6)",
					feedbackType: "1→4",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "String'nt",
				generalMidi: false,
				tags: ["harmonics", "literally_luigi_irl", "string", "picked"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						71, 71, 71, 86, 14, 29, 57, 71, 100, 100, 100, 57, 71, 86, 86, 86, 86, 86,
						71, 71, 71, 71, 71, 71, 86, 86, 86, 71,
					],
					unison: "bow",
					envelopes: [],
				},
			},
			{
				name: "A Bit of This and That",
				generalMidi: false,
				tags: ["pwm", "literally_luigi_irl", "novelty", "distortion"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
						"ring mod",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 13,
					detuneCents: -52,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					granular: 4,
					grainSize: 49,
					grainAmounts: 4,
					grainRange: 40,
					ringMod: 14,
					ringModHz: 100,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 100,
					echoSustain: 29,
					echoDelayBeats: 0.75,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 31,
					decimalOffset: 0,
					unison: "none",
					envelopes: [],
				},
			},
			// { name: "", generalMidi: false, tags:["", "literally_luigi_irl"], settings: {} },
		]),
	},
	{
		name: "SuP3r's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.3--------------
			{
				name: "The DGWF",
				generalMidi: false,
				tags: ["pickedstring", "sup3r", "guitar", "distortion"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
					],
					effects: ["pitch shift", "note filter", "distortion", "echo", "reverb"],
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2000,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2000,
							linearGain: 1,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 0.083,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "fifth",
					stringSustain: 29,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "echoDelay",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
						},
						{
							target: "stringSustain",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Faker Pulse",
				generalMidi: false,
				tags: ["harmonics", "sup3r", "retro", "chiptune"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["distortion"],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Hilltop Chip",
				generalMidi: false,
				tags: ["chip", "customchip", "sup3r", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					unison: "none",
					wave: "square",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": -1,
						"16": -1,
						"17": -2,
						"18": -4,
						"19": -6,
						"20": -6,
						"21": -7,
						"22": -8,
						"23": -10,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": -11,
						"40": -10,
						"41": -9,
						"42": -8,
						"43": -7,
						"44": -4,
						"45": -2,
						"46": -2,
						"47": -1,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Metallic Guitar",
				generalMidi: false,
				tags: ["noise", "sup3r", "distortion", "novelty", "guitar"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
					],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 62.5, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 62.5, linearGain: 0.0884 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "metallic",
					unison: "piano",
					envelopes: [{ target: "unison", envelope: "punch" }],
				},
			},
			{
				name: "Weird VRC6 Sawtooth",
				generalMidi: false,
				tags: ["chip", "customchip", "sup3r", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "fifth",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": -16,
						"3": 24,
						"4": 24,
						"5": -8,
						"6": 24,
						"7": 24,
						"8": -4,
						"9": 24,
						"10": 24,
						"11": 0,
						"12": 24,
						"13": 24,
						"14": 4,
						"15": 24,
						"16": 24,
						"17": 4,
						"18": 24,
						"19": 24,
						"20": 8,
						"21": 24,
						"22": 24,
						"23": 8,
						"24": 24,
						"25": 24,
						"26": 8,
						"27": 24,
						"28": 24,
						"29": 12,
						"30": 24,
						"31": 24,
						"32": 12,
						"33": 24,
						"34": 24,
						"35": 12,
						"36": 24,
						"37": 24,
						"38": 16,
						"39": 24,
						"40": 24,
						"41": 16,
						"42": 24,
						"43": 24,
						"44": 20,
						"45": 24,
						"46": 24,
						"47": 20,
						"48": 24,
						"49": 24,
						"50": 20,
						"51": 20,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Hallway Bell",
				generalMidi: false,
				tags: ["fm", "fm4op", "sup3r", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "distortion", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 }],
					distortion: 29,
					aliases: false,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Yah Yah Square",
				generalMidi: false,
				tags: ["chip", "chipwave", "sup3r", "retro", "distortion"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 2 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 2 },
					],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 43,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Waaffllee's Distortion Guitar",
				generalMidi: false,
				tags: ["pickedstring", "sup3r", "guitar", "distortion", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 0, 0, 100, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 14, 0, 0, 0,
					],
					unison: "octave",
					stringSustain: 71,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Happy Lead",
				generalMidi: false,
				tags: ["fm", "fm4op", "sup3r", "distortion", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 4,
						},
					],
					effects: ["vibrato", "note filter", "bitcrusher", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 57,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2 3)←4",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "3×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 10,
							waveform: "pulse width",
							pulseWidth: 2,
						},
						{ frequency: "~2×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "feedbackAmplitude",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Fingered Guitar",
				generalMidi: false,
				tags: ["harmonics", "sup3r", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.5,
						},
					],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 }],
					panDelay: 0,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						100, 71, 43, 43, 43, 43, 43, 43, 29, 43, 43, 29, 29, 29, 29, 29, 29, 29, 29,
						14, 14, 14, 14, 14, 14, 14, 14, 14,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell -1" }],
				},
			},
			{
				name: "SuP3rSaw",
				generalMidi: false,
				tags: ["supersaw", "sup3r", "retro", "distortion", "novelty"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.7071,
						},
					],
					effects: ["chord type", "note filter", "distortion", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					distortion: 86,
					aliases: false,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 100,
					spread: 0,
					shape: 83,
					envelopes: [],
				},
			},
			{
				name: "Shaky Guitar",
				generalMidi: false,
				tags: ["pickedstring", "sup3r", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 250,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 250,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"echo",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					echoSustain: 0,
					echoDelayBeats: 1.167,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						86, 86, 86, 71, 71, 86, 71, 71, 86, 100, 100, 86, 57, 43, 43, 43, 57, 43,
						43, 43, 29, 29, 14, 14, 14, 14, 14, 14,
					],
					unison: "none",
					stringSustain: 0,
					envelopes: [],
				},
			},
			{
				name: "Cat Purr",
				generalMidi: false,
				tags: ["fm", "fm4op", "sup3r", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 3222.02, linearGain: 1 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 2,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 0,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←(2 (3 (4",
					feedbackType: "1→4 2→3",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 9, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "flare 1" }],
				},
			},
			{
				name: "Dammed Souls",
				generalMidi: false,
				tags: ["fm", "fm4op", "sup3r", "retro", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["vibrato", "distortion", "bitcrusher"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 57,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
					],
				},
			},
			{
				name: "Static Bells",
				generalMidi: false,
				tags: ["chip", "chipwave", "sup3r", "retro", "distortion", "idiophone"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "bitcrusher", "echo"],
					transition: "normal",
					clicklessTransition: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "piano",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Harmonic triangle ",
				generalMidi: false,
				tags: ["pickedstring", "sup3r"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 2110.37, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["transition type", "chord type", "vibrato", "note filter"],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 29, 43, 0, 43, 14, 29, 14, 0, 0, 14, 14, 14, 0, 14, 0, 14, 0, 0, 0, 0,
						0, 0, 14, 0, 0, 14, 0,
					],
					unison: "none",
					stringSustain: 100,
					envelopes: [],
				},
			},
			{
				name: "Depressed piano",
				generalMidi: false,
				tags: ["chip", "customchip", "sup3r", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 1664.21, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 5,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "vibrate",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 24,
						"5": 24,
						"6": 24,
						"7": 24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 1" }],
				},
			},
			{
				name: "Odd bell",
				generalMidi: false,
				tags: ["harmonics", "sup3r", "idiophone"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 0, 86, 0, 0, 57, 0, 86, 0, 0, 86, 57, 0, 0, 100, 0, 0, 14, 57, 57, 0, 0,
						86, 0, 29, 57, 0, 0,
					],
					unison: "recurve",
					envelopes: [],
				},
			},
			{
				name: "picked pluck",
				generalMidi: false,
				tags: ["pickedstring", "sup3r", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "peak", cutoffHz: 4756.83, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 4756.83, linearGain: 0.1768 }],
					effects: ["transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 100, 0, 14, 0, 0, 71, 0, 0, 0, 0, 71, 57, 14, 0, 14, 14, 0, 100, 0, 0,
						86, 0, 29, 0, 0, 0, 0,
					],
					unison: "spinner",
					stringSustain: 21,
					envelopes: [],
				},
			},
			{
				name: "Supersaw Accordion",
				generalMidi: false,
				tags: ["supersaw", "sup3r", "retro", "bellows"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
					],
					effects: ["chord type", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					pulseWidth: 45,
					decimalOffset: 0,
					dynamism: 100,
					spread: 58,
					shape: 33,
					envelopes: [],
				},
			},
			{
				name: "purple water",
				generalMidi: false,
				tags: ["harmonics", "sup3r", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "peak", cutoffHz: 4000, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 4000, linearGain: 0.3536 }],
					effects: ["transition type", "note filter", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					harmonics: [
						71, 57, 86, 100, 71, 71, 57, 43, 29, 43, 29, 43, 29, 29, 29, 29, 14, 14, 14,
						14, 29, 14, 29, 29, 29, 29, 29, 29,
					],
					unison: "honky tonk",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang -1" }],
				},
			},
			{
				name: "harmonic choir",
				generalMidi: false,
				tags: ["harmonics", "sup3r", "keys"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					effects: ["echo", "reverb"],
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 1,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						100, 43, 29, 29, 14, 57, 14, 0, 43, 43, 43, 71, 57, 14, 57, 14, 0, 29, 29,
						14, 0, 14, 14, 0, 14, 14, 0, 14,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "smolsuitar",
				generalMidi: false,
				tags: ["pickedstring", "sup3r", "picked", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 714.63, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 3,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["chord type", "vibrato", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					harmonics: [
						100, 86, 57, 43, 29, 29, 29, 29, 29, 43, 29, 43, 43, 57, 57, 43, 29, 29, 29,
						29, 29, 43, 43, 29, 29, 29, 29, 29,
					],
					unison: "shimmer",
					stringSustain: 7,
					envelopes: [],
				},
			},
			{
				name: "Pulse Width Keys",
				generalMidi: false,
				tags: ["pwm", "sup3r", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.25 },
					],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 47,
					decimalOffset: 0,
					unison: "shimmer",
					envelopes: [],
				},
			},
			// { name: "", generalMidi: false, tags:["", "sup3r"], settings: {} },
		]),
	},
	{
		name: "RBLX_INST's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.3--------------
			{
				name: "Standard Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "rblx_inst", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.1768 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.1768 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.25 },
					],
					effects: ["pitch shift", "detune", "note filter", "distortion", "ring mod"],
					pitchShiftSemitones: 0,
					detuneCents: -24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.0884,
						},
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.0884,
						},
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 },
					],
					ringMod: 100,
					ringModHz: 11,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 0,
					aliases: false,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					algorithm: "1 2 3 4",
					feedbackType: "2⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "0.75×", amplitude: 15, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 8, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "fall",
							inverse: true,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Standard Snare (C2)",
				generalMidi: false,
				tags: ["noise", "rblx_inst", "snare"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1000, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1000, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.5 },
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "detune", "note filter", "distortion", "ring mod"],
					pitchShiftSemitones: 13,
					detuneCents: -80,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.1768 },
					],
					ringMod: 43,
					ringModHz: 11,
					ringModWaveformIndex: 8,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 14,
					aliases: false,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					wave: "brownian",
					unison: "broke",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 1.9,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "ringModulation",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Standard OHi-Hat",
				generalMidi: false,
				tags: ["noise", "rblx_inst", "hihat"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 5.6569 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 5.6569 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.7071 },
					],
					effects: [
						"pitch shift",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"ring mod",
					],
					pitchShiftSemitones: 21,
					detuneCents: -48,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 1.4142,
						},
						{ type: "high-pass", cutoffHz: 1681.79, linearGain: 0.3536 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 1.4142,
						},
						{ type: "high-pass", cutoffHz: 1681.79, linearGain: 0.3536 },
					],
					ringMod: 14,
					ringModHz: 100,
					ringModWaveformIndex: 8,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					wave: "1-bit white",
					unison: "triple octave",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Standard FHi-Hat",
				generalMidi: false,
				tags: ["noise", "rblx_inst", "hihat"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.125,
						},
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.125,
						},
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 5.6569 },
					],
					effects: ["pitch shift", "detune", "note filter", "bitcrusher", "ring mod"],
					pitchShiftSemitones: 24,
					detuneCents: 80,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 4756.83, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 1681.79,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 4756.83, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 1681.79,
							linearGain: 0.3536,
						},
					],
					ringMod: 43,
					ringModHz: 100,
					ringModWaveformIndex: 8,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					wave: "1-bit white",
					unison: "double octave",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 19,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Standard Cymbal1",
				generalMidi: false,
				tags: ["spectrum", "rblx_inst", "featured", "drum"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 5.6569,
						},
					],
					effects: [
						"pitch shift",
						"detune",
						"note filter",
						"granular",
						"chorus",
						"reverb",
						"ring mod",
					],
					pitchShiftSemitones: 0,
					detuneCents: -60,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 1,
						},
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 1.4142 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 1,
						},
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 1.4142 },
					],
					granular: 1,
					grainSize: 19,
					grainAmounts: 2,
					grainRange: 5,
					ringMod: 43,
					ringModHz: 60,
					ringModWaveformIndex: 8,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					chorus: 43,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					spectrum: [
						14, 14, 57, 43, 29, 29, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "double octave",
					envelopes: [
						{
							target: "pitchShift",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "noteFilterFreq",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "granular",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Chiptune_Punchy",
				generalMidi: false,
				tags: ["chip", "chipwave", "rblx_inst", "retro", "pad"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["vibrato", "chorus", "echo", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 15,
					vibratoSpeed: 11,
					vibratoType: 0,
					panDelay: 10,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "spiky",
					unison: "vary",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 6,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "funky alarm",
				generalMidi: false,
				tags: ["chip", "customchip", "rblx_inst", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/8 pulse",
					unison: "none",
					customChipWave: {
						"0": -2,
						"1": -2,
						"2": -8,
						"3": -8,
						"4": 8,
						"5": -19,
						"6": -17,
						"7": -17,
						"8": -15,
						"9": -13,
						"10": -11,
						"11": -10,
						"12": -5,
						"13": -5,
						"14": -3,
						"15": 2,
						"16": 3,
						"17": 4,
						"18": 6,
						"19": 7,
						"20": 8,
						"21": 9,
						"22": 14,
						"23": 14,
						"24": 19,
						"25": 19,
						"26": -24,
						"27": -24,
						"28": -23,
						"29": 14,
						"30": 14,
						"31": 14,
						"32": 14,
						"33": 14,
						"34": 14,
						"35": 14,
						"36": 14,
						"37": 14,
						"38": 19,
						"39": 19,
						"40": 19,
						"41": 19,
						"42": 19,
						"43": 19,
						"44": 19,
						"45": 19,
						"46": 19,
						"47": 19,
						"48": 19,
						"49": 9,
						"50": 3,
						"51": -1,
						"52": -11,
						"53": -11,
						"54": -9,
						"55": -8,
						"56": -4,
						"57": 1,
						"58": 5,
						"59": 10,
						"60": 11,
						"61": 14,
						"62": 18,
						"63": 22,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Crunchy_Snare",
				generalMidi: false,
				tags: ["noise", "rblx_inst", "snare"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.0884,
						},
					],
					effects: [
						"transition type",
						"pitch shift",
						"distortion",
						"bitcrusher",
						"chorus",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 19,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					wave: "crackling",
					unison: "triple octave",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Spacy Dualpulse",
				generalMidi: false,
				tags: ["chip", "customchip", "rblx_inst", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "peak", cutoffHz: 2828.43, linearGain: 8 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 2828.43, linearGain: 8 }],
					effects: ["transition type", "chord type", "pitch shift", "distortion", "echo"],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 24,
					distortion: 29,
					aliases: true,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "hum",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": -24,
						"33": -24,
						"34": -24,
						"35": -24,
						"36": -24,
						"37": -24,
						"38": -24,
						"39": -24,
						"40": -24,
						"41": -24,
						"42": -24,
						"43": -24,
						"44": -24,
						"45": -24,
						"46": -24,
						"47": -24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Chiptune_Bells",
				generalMidi: false,
				tags: ["harmonics", "rblx_inst", "retro", "idiophone"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "bitcrusher", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 14,
					echoSustain: 100,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0,
					],
					unison: "vary",
					envelopes: [],
				},
			},
			// -------------JukeBox 0.3.0--------------
			{
				name: "Sine_Piano",
				generalMidi: false,
				tags: ["chip", "chipwave", "rblx_inst", "idiophone", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					effects: ["detune", "chorus", "reverb"],
					detuneCents: -12,
					panDelay: 0,
					chorus: 43,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					unison: "piano",
					wave: "sine",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteVolume", envelope: "punch" },
						{
							target: "noteVolume",
							envelope: "tremolo5",
						},
						{ target: "detune", envelope: "punch" },
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "rblx_inst"], settings: {} },
		]),
	},
	{
		name: "Jayden256's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.3--------------
			{
				name: "N163 FM Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "retro", "chiptune"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 2, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Trumpet 3",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "retro"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1.4142 }],
					eqSubFilters1: [],
					effects: ["detune", "note filter"],
					detuneCents: -4,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "EClarinet",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "retro", "flute", "reed"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 4 },
					],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 6,
					algorithm: "1 2 3←4",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 1, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "2a03 Pulse",
				generalMidi: false,
				tags: ["pwm", "jayden256", "retro", "chiptune"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "peak", cutoffHz: 210.22, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 210.22, linearGain: 0.5 }],
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.16,
					vibratoDelay: 30,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Blip Square",
				generalMidi: false,
				tags: ["chip", "chipwave", "jayden256", "retro", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.7071,
						},
					],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "VRC6 Flute",
				generalMidi: false,
				tags: ["pwm", "jayden256", "flute", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.5,
						},
					],
					effects: ["transition type", "vibrato"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					pulseWidth: 38,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Laser Square Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "detune"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					detuneCents: 200,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "50×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "detune",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "2600 Bass v2",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "peak", cutoffHz: 176.78, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 176.78, linearGain: 0.5 }],
					effects: ["transition type", "detune"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: -20,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": 24,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": -24,
						"28": -24,
						"29": -24,
						"30": 24,
						"31": 24,
						"32": -24,
						"33": -24,
						"34": -24,
						"35": -24,
						"36": -24,
						"37": -24,
						"38": -24,
						"39": -24,
						"40": -24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": -24,
						"48": -24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": -24,
						"55": -24,
						"56": -24,
						"57": -24,
						"58": 24,
						"59": 24,
						"60": -24,
						"61": -24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "detune",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "eChorused Piano",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "retro", "keys"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 4 }],
					eqSubFilters1: [],
					effects: ["bitcrusher"],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 3,
					customAlgorithm: { mods: [[], [], [4], [], [], []], carrierCount: 6 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "19×", amplitude: 7, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "half-sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "eRhodes Piano",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "featured", "keys", "pad"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.5 },
					],
					effects: ["chord type", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					panDelay: 10,
					chorus: 100,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "Custom",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[4], [5], [6, 4], [], [], []], carrierCount: 3 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.6,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 5,
						},
						{
							target: "chorus",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Simple FM Piano",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "keys"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "ReuSlatflat Saw",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.25 }],
					eqSubFilters1: [],
					effects: ["chord type", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 23,
						"3": 22,
						"4": 21,
						"5": 21,
						"6": 20,
						"7": 24,
						"8": 18,
						"9": 18,
						"10": 17,
						"11": 16,
						"12": 15,
						"13": 15,
						"14": 14,
						"15": 24,
						"16": 12,
						"17": 12,
						"18": 11,
						"19": 10,
						"20": 9,
						"21": 9,
						"22": 8,
						"23": 24,
						"24": 6,
						"25": 6,
						"26": 5,
						"27": 4,
						"28": 3,
						"29": 3,
						"30": 2,
						"31": 24,
						"32": 0,
						"33": 0,
						"34": -1,
						"35": -2,
						"36": -3,
						"37": -3,
						"38": -4,
						"39": 24,
						"40": -6,
						"41": -6,
						"42": -7,
						"43": -8,
						"44": -9,
						"45": -9,
						"46": -10,
						"47": 24,
						"48": -12,
						"49": -12,
						"50": -13,
						"51": -14,
						"52": -15,
						"53": -15,
						"54": -16,
						"55": 24,
						"56": -18,
						"57": -18,
						"58": -19,
						"59": -20,
						"60": -21,
						"61": -21,
						"62": -22,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Supersaw Violin",
				generalMidi: false,
				tags: ["supersaw", "jayden256", "reed", "bellows"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: ["vibrato", "chorus", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 19,
					vibratoSpeed: 8,
					vibratoType: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 10,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 6,
					pulseWidth: 40,
					decimalOffset: 0,
					dynamism: 83,
					spread: 17,
					shape: 17,
					envelopes: [],
				},
			},
			{
				name: "Slap Square",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "retro", "picked"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					eqSubFilters1: [],
					effects: ["detune"],
					detuneCents: 164,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 3,
						},
						{
							target: "detune",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "FM Chorus Square",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "idiophone"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["chorus"],
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "VRC7 Vibraphone",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "idiophone", "bellows"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 }],
					eqSubFilters1: [],
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0,
					vibratoDelay: 1,
					vibratoSpeed: 8,
					vibratoType: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "15×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Grandiose Chip",
				generalMidi: false,
				tags: ["chip", "chipwave", "jayden256", "bellows"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 }],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					panDelay: 10,
					chorus: 100,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 72,
					wave: "lemmbox HD sawtooth",
					unison: "fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 512,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "unison",
							envelope: "linear",
							inverse: true,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "FM EPiano",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "keys", "picked"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.48,
					vibratoDelay: 28,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3) 2←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "SB5 Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "kick"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 (3 (4",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "13×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Advance Supersaw",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "retro", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["chorus"],
					panDelay: 10,
					chorus: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 0 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							waveform: 0,
							steps: 2,
						},
						{
							target: "chorus",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Square Snare",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "snare"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 (3 (4",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Synth Kick V2",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1 2 3 4",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "9×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 2, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "feedbackAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Simple FM Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "retro", "picked"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "DX7 Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "retro", "picked"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "FM Hihat",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "hihat", "retro"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["chorus"],
					panDelay: 0,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{
							frequency: "250×",
							amplitude: 15,
							waveform: "white noise",
							pulseWidth: 5,
						},
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "808 Tom",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "drum"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "808 HiTom",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "drum"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["detune"],
					detuneCents: -24,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "2A03 TriKick",
				generalMidi: false,
				tags: ["chip", "chipwave", "jayden256", "kick"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					effects: ["transition type", "pitch shift"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Synth Tom",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift"],
					pitchShiftSemitones: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1 2 3 4",
					feedbackType: "ALL",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 1, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "feedbackAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Holy Organ",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "bellows"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift"],
					pitchShiftSemitones: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1 2 3 4",
					feedbackType: "ALL",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 1, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "feedbackAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
					],
				},
			},
			{
				name: "EQ Saw",
				generalMidi: false,
				tags: ["chip", "chipwave", "jayden256", "retro", "pad"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 11.3137,
						},
					],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "lemmbox HD sawtooth",
					unison: "vary",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 512,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: true,
						},
					],
				},
			},
			{
				name: "Crystal Chimes",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "idiophone", "pad"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					effects: ["vibrato", "note filter", "bitcrusher", "chorus", "echo", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.24,
					vibratoDelay: 23,
					vibratoSpeed: 9,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 0.667,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 5, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Crushed Voice",
				generalMidi: false,
				tags: ["chip", "chipwave", "jayden256", "flute", "pad"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					effects: ["vibrato", "bitcrusher", "chorus", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 6,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					reverb: 19,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					wave: "lemmbox HD rounded",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 751,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "FM Metal Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "guitar", "distortion", "picked"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					customAlgorithm: { mods: [[2, 6], [3], [4], [5], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Distortion Guitar V2",
				generalMidi: false,
				tags: ["harmonics", "jayden256", "distortion", "guitar"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
					],
					effects: ["pitch shift", "vibrato", "distortion"],
					pitchShiftSemitones: 11,
					vibrato: "custom",
					vibratoDepth: 0.24,
					vibratoDelay: 20,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 71,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 86, 86, 71, 71, 71, 71, 57, 57, 43, 43,
						43, 29, 29, 14, 14, 14, 14, 14, 14, 14, 14,
					],
					unison: "shimmer",
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Overdrive Guitar V2",
				generalMidi: false,
				tags: ["harmonics", "jayden256", "guitar", "distortion"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
					],
					effects: ["distortion"],
					distortion: 71,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						86, 100, 100, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 57, 57, 57, 57,
						57, 43, 43, 43, 43, 29, 29, 29, 29, 14,
					],
					unison: "vary",
					envelopes: [],
				},
			},
			{
				name: "Nylon Guitar V2",
				generalMidi: false,
				tags: ["pickedstring", "jayden256", "guitar", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 1,
					noteFilter: [],
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 100, 86, 71, 86, 86, 100, 71, 71, 71, 71, 71, 71, 57, 43, 29, 43,
						43, 57, 57, 29, 29, 29, 29, 29, 14, 0,
					],
					unison: "none",
					stringSustain: 50,
					envelopes: [],
				},
			},
			{
				name: "Crazy Sine",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "retro", "chiptune", "distortion"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["transition type"],
					transition: "continue",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					customAlgorithm: {
						mods: [[3, 4, 5, 6], [4, 5, 6], [5, 6], [6], [], []],
						carrierCount: 1,
					},
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "feedbackAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Metallic Synth",
				generalMidi: false,
				tags: ["noise", "jayden256", "distortion"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					effects: ["detune", "distortion", "bitcrusher", "chorus"],
					detuneCents: 20,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "1-bit metallic",
					unison: "shimmer",
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.4--------------
			{
				name: "FM death bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "distortion", "guitar", "picked"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2,
						},
					],
					effects: ["distortion", "bitcrusher"],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "Custom",
					feedbackType: "1→5 2→6 3→4",
					feedbackAmplitude: 3,
					customAlgorithm: { mods: [[6, 2], [3], [4], [5], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 5, waveform: "absine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "FM metal bass 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "distortion", "picked"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 }],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 6,
					customAlgorithm: { mods: [[2, 6], [3], [4], [5], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "absine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 3, waveform: "absine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "absine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "808 Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "kick"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["detune"],
					detuneCents: -124,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 1.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "detune",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "909 Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "kick"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["detune", "distortion"],
					detuneCents: 200,
					distortion: 14,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "6×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "15×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "detune",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 19,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "JSquare",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 }],
					effects: ["transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "lemmbox trapasquare",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 23,
						"2": 22,
						"3": 21,
						"4": 20,
						"5": 19,
						"6": 18,
						"7": 18,
						"8": 13,
						"9": 14,
						"10": 15,
						"11": 16,
						"12": 15,
						"13": 14,
						"14": 13,
						"15": 14,
						"16": 14,
						"17": 13,
						"18": 14,
						"19": 15,
						"20": 16,
						"21": 15,
						"22": 14,
						"23": 13,
						"24": 18,
						"25": 18,
						"26": 19,
						"27": 20,
						"28": 21,
						"29": 22,
						"30": 23,
						"31": 24,
						"32": -24,
						"33": -23,
						"34": -22,
						"35": -21,
						"36": -20,
						"37": -19,
						"38": -18,
						"39": -18,
						"40": -13,
						"41": -14,
						"42": -15,
						"43": -16,
						"44": -15,
						"45": -14,
						"46": -13,
						"47": -14,
						"48": -14,
						"49": -13,
						"50": -14,
						"51": -15,
						"52": -16,
						"53": -15,
						"54": -14,
						"55": -13,
						"56": -18,
						"57": -18,
						"58": -19,
						"59": -20,
						"60": -21,
						"61": -22,
						"62": -23,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "RSquare",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "dirty",
					customChipWave: {
						"0": -24,
						"1": -23,
						"2": -23,
						"3": -23,
						"4": -23,
						"5": -18,
						"6": -23,
						"7": -16,
						"8": -22,
						"9": -16,
						"10": -21,
						"11": -21,
						"12": -21,
						"13": -20,
						"14": -21,
						"15": -19,
						"16": -3,
						"17": -17,
						"18": -17,
						"19": -16,
						"20": -16,
						"21": -14,
						"22": -16,
						"23": -18,
						"24": -16,
						"25": -16,
						"26": -16,
						"27": -15,
						"28": -17,
						"29": -15,
						"30": -14,
						"31": -14,
						"32": 24,
						"33": 22,
						"34": 20,
						"35": 19,
						"36": 19,
						"37": 19,
						"38": 3,
						"39": 9,
						"40": 20,
						"41": 8,
						"42": 17,
						"43": 16,
						"44": 15,
						"45": 16,
						"46": 17,
						"47": 17,
						"48": 17,
						"49": 17,
						"50": 21,
						"51": 16,
						"52": 16,
						"53": 22,
						"54": 9,
						"55": 16,
						"56": 16,
						"57": 17,
						"58": 15,
						"59": 14,
						"60": 13,
						"61": 13,
						"62": 14,
						"63": 16,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "UltraSaw",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "retro", "pad"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					customAlgorithm: {
						mods: [[5, 4, 3, 2, 6], [6], [4, 5, 6], [5, 6], [6], []],
						carrierCount: 6,
					},
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Pluto pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.5 }],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "modbox flatline",
					unison: "honky tonk",
					customChipWave: {
						"0": 24,
						"1": 22,
						"2": 21,
						"3": 20,
						"4": 20,
						"5": 19,
						"6": 17,
						"7": 15,
						"8": 14,
						"9": 14,
						"10": 13,
						"11": 12,
						"12": 10,
						"13": 9,
						"14": 9,
						"15": 8,
						"16": 7,
						"17": 6,
						"18": 5,
						"19": 4,
						"20": 4,
						"21": 3,
						"22": 2,
						"23": 2,
						"24": 1,
						"25": 0,
						"26": -1,
						"27": -2,
						"28": -3,
						"29": -4,
						"30": -4,
						"31": -5,
						"32": -4,
						"33": -3,
						"34": -3,
						"35": -2,
						"36": -1,
						"37": 0,
						"38": 1,
						"39": 2,
						"40": 3,
						"41": 4,
						"42": 5,
						"43": 6,
						"44": 7,
						"45": 7,
						"46": 8,
						"47": 9,
						"48": 9,
						"49": 10,
						"50": 10,
						"51": 11,
						"52": -20,
						"53": -21,
						"54": -21,
						"55": -22,
						"56": -22,
						"57": -23,
						"58": -23,
						"59": -23,
						"60": -24,
						"61": -24,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: true,
						},
					],
				},
			},
			{
				name: "Cracked piano",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "keys", "distortion", "retro"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 4,
						},
					],
					eqSubFilters1: [],
					effects: ["bitcrusher"],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←(2 (3 (4 (5 (6",
					feedbackType: "1↔4 2↔5 3↔6",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "sharksine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 10, waveform: "fastsine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "FM EPiano 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "keys"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "15×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "contrabass 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "bellows", "distortion"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4 5←6",
					feedbackType: "1→5 2→6 3→4",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "303 Acid",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "picked", "bellows"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.0884 }],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 3363.59, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 3363.59, linearGain: 2.8284 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 24,
						"3": 23,
						"4": 23,
						"5": 22,
						"6": 22,
						"7": 22,
						"8": 21,
						"9": 21,
						"10": 20,
						"11": 20,
						"12": 19,
						"13": 18,
						"14": 17,
						"15": 16,
						"16": 16,
						"17": 16,
						"18": 16,
						"19": 15,
						"20": 14,
						"21": 13,
						"22": 13,
						"23": 12,
						"24": 10,
						"25": 9,
						"26": 8,
						"27": 7,
						"28": 6,
						"29": 4,
						"30": 2,
						"31": 1,
						"32": 0,
						"33": -1,
						"34": -3,
						"35": -5,
						"36": -6,
						"37": -7,
						"38": -9,
						"39": -10,
						"40": -10,
						"41": -11,
						"42": -11,
						"43": -12,
						"44": -12,
						"45": -14,
						"46": -15,
						"47": -16,
						"48": -16,
						"49": -17,
						"50": -18,
						"51": -19,
						"52": -19,
						"53": -20,
						"54": -20,
						"55": -21,
						"56": -21,
						"57": -22,
						"58": -22,
						"59": -23,
						"60": -23,
						"61": -24,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Synth Clavinet",
				generalMidi: false,
				tags: ["supersaw", "jayden256", "featured", "picked", "string", "distortion"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 14,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 15,
					decimalOffset: 0,
					dynamism: 67,
					spread: 42,
					shape: 67,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "S-Pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "bellows", "string", "pad"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 }],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 5656.85, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 5656.85, linearGain: 0.3536 }],
					panDelay: 10,
					chorus: 71,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "sandbox r-sawtooth",
					unison: "honky tonk",
					customChipWave: {
						"0": -24,
						"1": -22,
						"2": -19,
						"3": -17,
						"4": -16,
						"5": -14,
						"6": -13,
						"7": -11,
						"8": -10,
						"9": -9,
						"10": -8,
						"11": -7,
						"12": -7,
						"13": -7,
						"14": -7,
						"15": -6,
						"16": 22,
						"17": 22,
						"18": 21,
						"19": 21,
						"20": 20,
						"21": 20,
						"22": 19,
						"23": 19,
						"24": 19,
						"25": 19,
						"26": 20,
						"27": 20,
						"28": 21,
						"29": 22,
						"30": 22,
						"31": 23,
						"32": 0,
						"33": 0,
						"34": -1,
						"35": -1,
						"36": -1,
						"37": -2,
						"38": -2,
						"39": -2,
						"40": -2,
						"41": -2,
						"42": -2,
						"43": -1,
						"44": -1,
						"45": 1,
						"46": 1,
						"47": 2,
						"48": 19,
						"49": 20,
						"50": 21,
						"51": 21,
						"52": 22,
						"53": 22,
						"54": 22,
						"55": 22,
						"56": 22,
						"57": 22,
						"58": 22,
						"59": 22,
						"60": 21,
						"61": 21,
						"62": 20,
						"63": 19,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "unison",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			// -------------JukeBox 0.3.0--------------
			{
				name: "Q-Pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 }],
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 10,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "spinner",
					customChipWave: {
						"0": 15,
						"1": 16,
						"2": 17,
						"3": 17,
						"4": 18,
						"5": 18,
						"6": 19,
						"7": 19,
						"8": 19,
						"9": 19,
						"10": -17,
						"11": -18,
						"12": -19,
						"13": -19,
						"14": -19,
						"15": -19,
						"16": -19,
						"17": -18,
						"18": -18,
						"19": 0,
						"20": 1,
						"21": 2,
						"22": 3,
						"23": 4,
						"24": 4,
						"25": 5,
						"26": 6,
						"27": 6,
						"28": 12,
						"29": 9,
						"30": 7,
						"31": 5,
						"32": 2,
						"33": 0,
						"34": -2,
						"35": -3,
						"36": -3,
						"37": 22,
						"38": 21,
						"39": 20,
						"40": 20,
						"41": 20,
						"42": 20,
						"43": 21,
						"44": 21,
						"45": 23,
						"46": 11,
						"47": 12,
						"48": 12,
						"49": 10,
						"50": 7,
						"51": 6,
						"52": 6,
						"53": 11,
						"54": 12,
						"55": 21,
						"56": 19,
						"57": 17,
						"58": 14,
						"59": 12,
						"60": 11,
						"61": 17,
						"62": 16,
						"63": 14,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Dawnsoft Bass",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune", "featured"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 0.5,
						},
					],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 57,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "square",
					unison: "detune",
					customChipWave: {
						"0": 24,
						"1": 21,
						"2": 19,
						"3": 16,
						"4": 13,
						"5": 7,
						"6": -4,
						"7": -3,
						"8": -1,
						"9": 1,
						"10": -12,
						"11": -14,
						"12": -17,
						"13": -20,
						"14": -23,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -7,
						"19": -2,
						"20": 0,
						"21": 0,
						"22": -6,
						"23": -8,
						"24": -8,
						"25": -4,
						"26": 0,
						"27": 3,
						"28": 6,
						"29": 7,
						"30": -4,
						"31": 3,
						"32": 5,
						"33": 1,
						"34": -4,
						"35": -4,
						"36": 4,
						"37": 3,
						"38": 3,
						"39": 5,
						"40": 9,
						"41": 14,
						"42": 16,
						"43": 15,
						"44": 14,
						"45": 12,
						"46": 6,
						"47": 6,
						"48": 0,
						"49": -5,
						"50": -6,
						"51": -6,
						"52": -6,
						"53": -6,
						"54": -6,
						"55": -6,
						"56": -5,
						"57": -2,
						"58": 1,
						"59": 5,
						"60": 9,
						"61": 13,
						"62": 19,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Buzzy Square",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "bellows", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.25 }],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "square",
					unison: "bowed",
					customChipWave: {
						"0": 24,
						"1": 20,
						"2": 16,
						"3": 14,
						"4": 14,
						"5": 11,
						"6": 10,
						"7": 10,
						"8": 9,
						"9": 9,
						"10": 9,
						"11": 9,
						"12": 10,
						"13": 11,
						"14": 11,
						"15": 11,
						"16": 12,
						"17": 12,
						"18": 14,
						"19": 14,
						"20": 15,
						"21": 17,
						"22": 18,
						"23": 19,
						"24": 21,
						"25": 21,
						"26": 21,
						"27": 21,
						"28": 22,
						"29": 22,
						"30": 23,
						"31": 23,
						"32": -24,
						"33": -24,
						"34": -23,
						"35": -22,
						"36": -20,
						"37": -19,
						"38": -18,
						"39": -16,
						"40": -15,
						"41": -12,
						"42": -11,
						"43": -10,
						"44": -8,
						"45": -6,
						"46": -5,
						"47": -4,
						"48": -2,
						"49": -1,
						"50": 0,
						"51": 1,
						"52": 3,
						"53": 4,
						"54": 5,
						"55": 5,
						"56": 6,
						"57": 6,
						"58": 7,
						"59": -16,
						"60": -16,
						"61": -17,
						"62": -13,
						"63": -6,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "unison",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Temusoft bass",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 22,
						"1": 18,
						"2": 19,
						"3": 20,
						"4": 21,
						"5": 22,
						"6": 24,
						"7": 24,
						"8": 18,
						"9": 12,
						"10": 4,
						"11": -4,
						"12": -14,
						"13": -11,
						"14": -10,
						"15": -6,
						"16": -3,
						"17": -7,
						"18": -7,
						"19": -4,
						"20": -3,
						"21": -6,
						"22": -9,
						"23": -17,
						"24": -22,
						"25": -18,
						"26": -14,
						"27": -12,
						"28": -7,
						"29": -5,
						"30": -15,
						"31": -24,
						"32": -5,
						"33": -3,
						"34": -12,
						"35": -9,
						"36": -7,
						"37": -6,
						"38": -6,
						"39": -6,
						"40": -5,
						"41": -6,
						"42": -1,
						"43": -4,
						"44": -3,
						"45": -1,
						"46": -2,
						"47": -3,
						"48": -1,
						"49": -2,
						"50": -6,
						"51": -10,
						"52": -13,
						"53": -15,
						"54": -12,
						"55": -9,
						"56": -6,
						"57": -2,
						"58": 1,
						"59": 4,
						"60": 6,
						"61": 7,
						"62": 19,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "GB Kick",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "kick"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					effects: ["transition type", "pitch shift", "detune"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					detuneCents: -200,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": -1,
						"2": -2,
						"3": -5,
						"4": -7,
						"5": -11,
						"6": -12,
						"7": -16,
						"8": -17,
						"9": -18,
						"10": -19,
						"11": -20,
						"12": -22,
						"13": -22,
						"14": -23,
						"15": -23,
						"16": -24,
						"17": -23,
						"18": -23,
						"19": -23,
						"20": -22,
						"21": -21,
						"22": -20,
						"23": -19,
						"24": -18,
						"25": -17,
						"26": -14,
						"27": -12,
						"28": -10,
						"29": -7,
						"30": -4,
						"31": -3,
						"32": 0,
						"33": 2,
						"34": 4,
						"35": 6,
						"36": 8,
						"37": 12,
						"38": 13,
						"39": 17,
						"40": 18,
						"41": 19,
						"42": 20,
						"43": 21,
						"44": 23,
						"45": 23,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 23,
						"53": 22,
						"54": 21,
						"55": 20,
						"56": 19,
						"57": 18,
						"58": 15,
						"59": 13,
						"60": 11,
						"61": 8,
						"62": 5,
						"63": 3,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Night Vision",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "picked", "string"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 86,
					reverb: 77,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					algorithm: "Custom",
					feedbackType: "ALL",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 6], [3], [], [6, 5], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "25×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "GSquare",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					effects: ["note filter", "distortion", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -19,
						"2": -14,
						"3": -16,
						"4": -11,
						"5": -13,
						"6": -8,
						"7": -11,
						"8": -6,
						"9": -5,
						"10": -6,
						"11": -3,
						"12": -3,
						"13": -2,
						"14": -3,
						"15": 0,
						"16": 1,
						"17": 0,
						"18": 1,
						"19": 0,
						"20": 1,
						"21": 1,
						"22": 1,
						"23": 1,
						"24": 0,
						"25": 1,
						"26": 2,
						"27": 1,
						"28": 0,
						"29": 1,
						"30": 1,
						"31": 1,
						"32": 24,
						"33": 19,
						"34": 16,
						"35": 11,
						"36": 8,
						"37": 11,
						"38": 6,
						"39": 5,
						"40": 4,
						"41": 3,
						"42": 6,
						"43": 2,
						"44": 1,
						"45": 1,
						"46": 0,
						"47": 0,
						"48": -1,
						"49": -1,
						"50": 0,
						"51": -1,
						"52": -1,
						"53": 0,
						"54": 0,
						"55": -1,
						"56": -1,
						"57": -1,
						"58": -1,
						"59": -1,
						"60": 0,
						"61": 0,
						"62": -1,
						"63": -1,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "XSquare",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					effects: ["bitcrusher"],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -23,
						"2": -23,
						"3": -22,
						"4": -22,
						"5": -22,
						"6": -21,
						"7": -21,
						"8": -21,
						"9": -21,
						"10": -20,
						"11": -20,
						"12": -20,
						"13": -19,
						"14": -19,
						"15": -18,
						"16": -18,
						"17": -18,
						"18": -17,
						"19": -17,
						"20": -17,
						"21": -16,
						"22": -16,
						"23": -16,
						"24": -16,
						"25": -16,
						"26": -15,
						"27": -14,
						"28": -14,
						"29": -13,
						"30": -13,
						"31": -13,
						"32": 24,
						"33": -12,
						"34": 24,
						"35": -12,
						"36": 24,
						"37": 24,
						"38": 23,
						"39": 23,
						"40": 22,
						"41": 22,
						"42": 22,
						"43": 21,
						"44": 21,
						"45": 21,
						"46": 21,
						"47": 20,
						"48": 20,
						"49": 19,
						"50": 19,
						"51": 18,
						"52": 18,
						"53": 17,
						"54": 17,
						"55": 17,
						"56": 16,
						"57": 16,
						"58": 15,
						"59": 14,
						"60": 14,
						"61": 13,
						"62": 13,
						"63": 12,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "B-Triangle",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					effects: ["transition type"],
					transition: "continue",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "triangle",
					unison: "vary",
					customChipWave: {
						"0": -24,
						"1": -23,
						"2": -22,
						"3": -20,
						"4": -19,
						"5": -17,
						"6": -14,
						"7": -13,
						"8": -12,
						"9": -10,
						"10": -9,
						"11": -9,
						"12": -7,
						"13": -4,
						"14": -1,
						"15": -1,
						"16": 0,
						"17": 4,
						"18": 5,
						"19": 7,
						"20": 10,
						"21": 12,
						"22": 12,
						"23": 14,
						"24": 16,
						"25": 17,
						"26": 17,
						"27": 19,
						"28": 20,
						"29": 21,
						"30": 23,
						"31": 24,
						"32": 24,
						"33": 23,
						"34": 21,
						"35": 20,
						"36": 19,
						"37": 17,
						"38": 15,
						"39": 13,
						"40": 12,
						"41": 11,
						"42": 10,
						"43": 9,
						"44": 8,
						"45": 7,
						"46": 6,
						"47": 3,
						"48": 1,
						"49": 0,
						"50": -1,
						"51": -2,
						"52": -4,
						"53": -6,
						"54": -8,
						"55": -9,
						"56": -10,
						"57": -12,
						"58": -15,
						"59": -17,
						"60": -19,
						"61": -21,
						"62": -23,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "unison",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "1/4/8 Pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "featured", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					eqSubFilters1: [],
					effects: ["detune", "chorus", "reverb"],
					detuneCents: -2,
					panDelay: 0,
					chorus: 14,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -23,
						"2": -22,
						"3": -21,
						"4": -20,
						"5": -19,
						"6": -18,
						"7": -17,
						"8": -16,
						"9": 20,
						"10": -15,
						"11": 21,
						"12": -14,
						"13": 22,
						"14": -13,
						"15": 23,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 23,
						"21": 23,
						"22": 23,
						"23": 23,
						"24": 22,
						"25": 22,
						"26": 22,
						"27": 22,
						"28": 22,
						"29": 22,
						"30": 22,
						"31": 22,
						"32": 21,
						"33": 21,
						"34": 21,
						"35": 21,
						"36": 21,
						"37": 21,
						"38": 21,
						"39": 21,
						"40": 20,
						"41": 20,
						"42": 20,
						"43": 20,
						"44": 20,
						"45": 20,
						"46": 20,
						"47": 20,
						"48": 20,
						"49": 20,
						"50": 20,
						"51": 20,
						"52": 20,
						"53": 20,
						"54": 20,
						"55": 20,
						"56": 20,
						"57": 20,
						"58": 20,
						"59": 20,
						"60": 20,
						"61": 20,
						"62": 20,
						"63": 20,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "FDS 2C33 thingy",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 12,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 48,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 23,
						"2": 22,
						"3": 21,
						"4": 20,
						"5": 18,
						"6": 16,
						"7": 13,
						"8": 10,
						"9": 7,
						"10": 3,
						"11": -1,
						"12": -4,
						"13": -9,
						"14": -12,
						"15": -15,
						"16": -19,
						"17": -21,
						"18": -21,
						"19": -20,
						"20": -18,
						"21": -17,
						"22": -16,
						"23": -14,
						"24": -11,
						"25": -10,
						"26": -8,
						"27": -7,
						"28": -6,
						"29": -4,
						"30": -2,
						"31": 3,
						"32": 3,
						"33": -2,
						"34": -4,
						"35": -6,
						"36": -7,
						"37": -8,
						"38": -10,
						"39": -11,
						"40": -14,
						"41": -16,
						"42": -17,
						"43": -18,
						"44": -20,
						"45": -21,
						"46": -21,
						"47": -19,
						"48": -15,
						"49": -12,
						"50": -9,
						"51": -5,
						"52": -1,
						"53": 3,
						"54": 7,
						"55": 10,
						"56": 13,
						"57": 16,
						"58": 18,
						"59": 20,
						"60": 21,
						"61": 22,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "D-Saw",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					eqSubFilters1: [],
					effects: ["bitcrusher"],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "square",
					unison: "piano",
					customChipWave: {
						"0": -2,
						"1": 0,
						"2": 1,
						"3": 3,
						"4": 4,
						"5": 6,
						"6": 8,
						"7": 9,
						"8": 11,
						"9": 12,
						"10": 14,
						"11": 15,
						"12": 17,
						"13": 18,
						"14": 19,
						"15": 20,
						"16": 21,
						"17": 22,
						"18": 23,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": -22,
						"25": -23,
						"26": -24,
						"27": -22,
						"28": 20,
						"29": 20,
						"30": 19,
						"31": 19,
						"32": 18,
						"33": 17,
						"34": 16,
						"35": 15,
						"36": 14,
						"37": 13,
						"38": 12,
						"39": 10,
						"40": 8,
						"41": 6,
						"42": 5,
						"43": 5,
						"44": -23,
						"45": -22,
						"46": -21,
						"47": -19,
						"48": -18,
						"49": -17,
						"50": -16,
						"51": -15,
						"52": -13,
						"53": -12,
						"54": -11,
						"55": -10,
						"56": -8,
						"57": -6,
						"58": -4,
						"59": -4,
						"60": -4,
						"61": -3,
						"62": -3,
						"63": -3,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "ATBass",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					effects: ["transition type", "detune"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: -96,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -21,
						"2": -21,
						"3": -13,
						"4": -20,
						"5": -20,
						"6": -21,
						"7": -21,
						"8": -20,
						"9": 24,
						"10": 21,
						"11": 22,
						"12": 15,
						"13": 18,
						"14": 22,
						"15": -24,
						"16": -24,
						"17": -23,
						"18": 24,
						"19": 22,
						"20": 23,
						"21": -20,
						"22": -24,
						"23": -23,
						"24": 5,
						"25": 24,
						"26": 23,
						"27": -24,
						"28": -24,
						"29": -23,
						"30": 23,
						"31": 24,
						"32": -24,
						"33": -24,
						"34": -22,
						"35": -21,
						"36": -20,
						"37": -22,
						"38": -15,
						"39": -21,
						"40": -20,
						"41": 24,
						"42": 22,
						"43": 21,
						"44": 23,
						"45": 22,
						"46": 22,
						"47": -23,
						"48": -24,
						"49": 19,
						"50": 24,
						"51": 19,
						"52": 23,
						"53": 22,
						"54": -24,
						"55": -24,
						"56": -23,
						"57": -23,
						"58": 23,
						"59": 24,
						"60": -23,
						"61": -24,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "detune",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
					],
				},
			},
			{
				name: "Spooky PWM",
				generalMidi: false,
				tags: ["pwm", "jayden256", "picked"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "detune", "vibrato", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: -200,
					vibrato: "custom",
					vibratoDepth: 0.44,
					vibratoDelay: 10,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "detune",
							envelope: "fall",
							inverse: true,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Nostalgic Box",
				generalMidi: false,
				tags: ["pickedstring", "jayden256", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 }],
					effects: ["bitcrusher", "chorus", "reverb"],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 57,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 86, 57, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 0,
					unisonOffset: 0.104,
					unisonExpression: 1,
					unisonSign: 1,
					stringSustain: 57,
					envelopes: [],
				},
			},
			{
				name: "303 Acid 2",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "picked", "bellows", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 2,
						},
					],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 2.8284,
						},
					],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 23,
						"1": 24,
						"2": 11,
						"3": 10,
						"4": 24,
						"5": 13,
						"6": 24,
						"7": 11,
						"8": 24,
						"9": 23,
						"10": 23,
						"11": 22,
						"12": 22,
						"13": 21,
						"14": 21,
						"15": 18,
						"16": 16,
						"17": 19,
						"18": 5,
						"19": 17,
						"20": 15,
						"21": 14,
						"22": 11,
						"23": 12,
						"24": 4,
						"25": 8,
						"26": 4,
						"27": 6,
						"28": 5,
						"29": 1,
						"30": 0,
						"31": -1,
						"32": -2,
						"33": -3,
						"34": -5,
						"35": -6,
						"36": -8,
						"37": -2,
						"38": -11,
						"39": -12,
						"40": -13,
						"41": -10,
						"42": -13,
						"43": -15,
						"44": -7,
						"45": -19,
						"46": -19,
						"47": -12,
						"48": -18,
						"49": -20,
						"50": -15,
						"51": -21,
						"52": -21,
						"53": -22,
						"54": -22,
						"55": -18,
						"56": -22,
						"57": -21,
						"58": -23,
						"59": -23,
						"60": -20,
						"61": -24,
						"62": -24,
						"63": -23,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Brass Synth 4",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "distortion", "string"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					panDelay: 10,
					reverb: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Boopy",
				generalMidi: false,
				tags: ["fm", "fm6op", "jayden256", "picked"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus", "reverb"],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 29,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "PSG Lead",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					eqSubFilters1: [],
					effects: ["distortion", "chorus"],
					distortion: 29,
					aliases: false,
					panDelay: 0,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 22,
						"2": 18,
						"3": 17,
						"4": 17,
						"5": 16,
						"6": 15,
						"7": 15,
						"8": 14,
						"9": 13,
						"10": 13,
						"11": 13,
						"12": 12,
						"13": 12,
						"14": 13,
						"15": 16,
						"16": 17,
						"17": 18,
						"18": 19,
						"19": 20,
						"20": 20,
						"21": 21,
						"22": 21,
						"23": 21,
						"24": 22,
						"25": 22,
						"26": 23,
						"27": 23,
						"28": 23,
						"29": 23,
						"30": 23,
						"31": 23,
						"32": -20,
						"33": -22,
						"34": -23,
						"35": -24,
						"36": -23,
						"37": -23,
						"38": -22,
						"39": -21,
						"40": -20,
						"41": -18,
						"42": -18,
						"43": -19,
						"44": -20,
						"45": -21,
						"46": -22,
						"47": -24,
						"48": -22,
						"49": -21,
						"50": -18,
						"51": -13,
						"52": -12,
						"53": -15,
						"54": -18,
						"55": -19,
						"56": -16,
						"57": -12,
						"58": -9,
						"59": -8,
						"60": -8,
						"61": -8,
						"62": -8,
						"63": -8,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Synth Bass 101",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "picked"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 2000,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 2000,
							linearGain: 2,
						},
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "hum",
					customChipWave: {
						"0": 0,
						"1": 2,
						"2": 4,
						"3": 7,
						"4": 10,
						"5": 13,
						"6": 15,
						"7": 17,
						"8": 20,
						"9": 22,
						"10": 23,
						"11": 24,
						"12": 23,
						"13": 19,
						"14": 15,
						"15": 7,
						"16": 4,
						"17": 4,
						"18": 7,
						"19": 9,
						"20": 11,
						"21": 13,
						"22": 15,
						"23": 17,
						"24": 18,
						"25": 6,
						"26": 0,
						"27": 3,
						"28": 8,
						"29": 11,
						"30": 19,
						"31": 21,
						"32": -7,
						"33": -16,
						"34": -23,
						"35": -23,
						"36": -22,
						"37": -20,
						"38": -18,
						"39": -16,
						"40": -15,
						"41": -11,
						"42": -11,
						"43": -11,
						"44": -15,
						"45": -18,
						"46": -20,
						"47": -22,
						"48": -19,
						"49": -17,
						"50": -14,
						"51": -12,
						"52": -11,
						"53": -9,
						"54": -8,
						"55": -12,
						"56": -15,
						"57": -14,
						"58": -12,
						"59": -8,
						"60": -6,
						"61": -4,
						"62": -1,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Chip Voice Pad",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "bellows", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.5 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "double saw",
					unison: "hum",
					customChipWave: {
						"0": -17,
						"1": -18,
						"2": -19,
						"3": -20,
						"4": -21,
						"5": -22,
						"6": -23,
						"7": -24,
						"8": -8,
						"9": -7,
						"10": -6,
						"11": -5,
						"12": -4,
						"13": -3,
						"14": -2,
						"15": 0,
						"16": 24,
						"17": 23,
						"18": 22,
						"19": 21,
						"20": 20,
						"21": 19,
						"22": 18,
						"23": 17,
						"24": -24,
						"25": -23,
						"26": -22,
						"27": -21,
						"28": -20,
						"29": -19,
						"30": -18,
						"31": -17,
						"32": 17,
						"33": 18,
						"34": 19,
						"35": 20,
						"36": 21,
						"37": 22,
						"38": 23,
						"39": 24,
						"40": -17,
						"41": -18,
						"42": -19,
						"43": -20,
						"44": -21,
						"45": -22,
						"46": -23,
						"47": -24,
						"48": -8,
						"49": -6,
						"50": -5,
						"51": -4,
						"52": -3,
						"53": -2,
						"54": -1,
						"55": 0,
						"56": 24,
						"57": 23,
						"58": 22,
						"59": 21,
						"60": 20,
						"61": 19,
						"62": 18,
						"63": 17,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Z-Saw",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 7,
					vibratoSpeed: 3,
					vibratoType: 1,
					panDelay: 10,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 48,
					wave: "square",
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 0.001,
					unisonOffset: 0,
					unisonExpression: 0.85,
					unisonSign: 1.6,
					customChipWave: {
						"0": -24,
						"1": -23,
						"2": -22,
						"3": -21,
						"4": -20,
						"5": -19,
						"6": -18,
						"7": -17,
						"8": -16,
						"9": -15,
						"10": -14,
						"11": -13,
						"12": -12,
						"13": -11,
						"14": -10,
						"15": -9,
						"16": -1,
						"17": -1,
						"18": -1,
						"19": -1,
						"20": -1,
						"21": -1,
						"22": -1,
						"23": -1,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 1,
						"33": 1,
						"34": 1,
						"35": 1,
						"36": 1,
						"37": 1,
						"38": 1,
						"39": 1,
						"40": 2,
						"41": 2,
						"42": 2,
						"43": 2,
						"44": 2,
						"45": 2,
						"46": 2,
						"47": 2,
						"48": 9,
						"49": 10,
						"50": 11,
						"51": 12,
						"52": 13,
						"53": 14,
						"54": 15,
						"55": 16,
						"56": 17,
						"57": 18,
						"58": 19,
						"59": 20,
						"60": 21,
						"61": 22,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Chip Trumpet",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 22,
					vibratoSpeed: 5,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					panDelay: 10,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 19,
						"2": 15,
						"3": 12,
						"4": 10,
						"5": 8,
						"6": 6,
						"7": 5,
						"8": 4,
						"9": 3,
						"10": 2,
						"11": 2,
						"12": 1,
						"13": 1,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": -1,
						"51": -1,
						"52": -2,
						"53": -2,
						"54": -3,
						"55": -4,
						"56": -5,
						"57": -6,
						"58": -8,
						"59": -10,
						"60": -12,
						"61": -16,
						"62": -19,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "P-Triangle",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type"],
					transition: "continue",
					clicklessTransition: true,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "dissonant",
					customChipWave: {
						"0": 24,
						"1": 22,
						"2": 21,
						"3": 19,
						"4": 17,
						"5": 16,
						"6": 14,
						"7": 12,
						"8": 11,
						"9": 9,
						"10": 7,
						"11": 6,
						"12": 4,
						"13": 2,
						"14": 1,
						"15": -1,
						"16": -3,
						"17": -4,
						"18": -6,
						"19": -8,
						"20": -9,
						"21": -11,
						"22": -13,
						"23": -14,
						"24": -16,
						"25": -17,
						"26": -18,
						"27": -19,
						"28": -20,
						"29": -22,
						"30": -23,
						"31": -24,
						"32": -24,
						"33": -22,
						"34": -20,
						"35": -18,
						"36": -16,
						"37": -14,
						"38": -12,
						"39": -10,
						"40": -9,
						"41": -7,
						"42": -5,
						"43": -3,
						"44": -1,
						"45": 1,
						"46": 2,
						"47": 4,
						"48": 5,
						"49": 6,
						"50": 7,
						"51": 9,
						"52": 10,
						"53": 11,
						"54": 13,
						"55": 14,
						"56": 15,
						"57": 16,
						"58": 18,
						"59": 19,
						"60": 20,
						"61": 21,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "unison",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 3,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Chip Flute",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "featured", "retro", "flute"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 2.8284 }],
					eqSubFilters1: [],
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 11,
					vibratoSpeed: 6,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0.075,
					fadeOutTicks: 96,
					wave: "square",
					unison: "vary",
					customChipWave: {
						"0": 20,
						"1": 18,
						"2": 16,
						"3": 14,
						"4": 12,
						"5": 10,
						"6": 8,
						"7": 6,
						"8": 4,
						"9": 2,
						"10": 0,
						"11": -2,
						"12": -4,
						"13": -6,
						"14": -8,
						"15": -10,
						"16": -12,
						"17": -14,
						"18": -16,
						"19": -18,
						"20": -20,
						"21": -22,
						"22": -24,
						"23": -23,
						"24": -24,
						"25": -23,
						"26": -24,
						"27": -23,
						"28": -24,
						"29": -23,
						"30": -21,
						"31": -19,
						"32": -21,
						"33": -19,
						"34": -17,
						"35": -15,
						"36": -13,
						"37": -11,
						"38": -9,
						"39": -7,
						"40": -5,
						"41": -3,
						"42": -1,
						"43": 1,
						"44": 3,
						"45": 5,
						"46": 7,
						"47": 9,
						"48": 11,
						"49": 13,
						"50": 15,
						"51": 17,
						"52": 19,
						"53": 21,
						"54": 23,
						"55": 24,
						"56": 23,
						"57": 22,
						"58": 21,
						"59": 20,
						"60": 19,
						"61": 21,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "C-Saw",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 1.4142 }],
					eqSubFilters1: [],
					effects: ["transition type", "chord type"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 22,
					monoChordTone: 1,
					panDelay: 10,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -23,
						"2": -22,
						"3": -21,
						"4": -16,
						"5": -15,
						"6": -14,
						"7": -13,
						"8": -20,
						"9": -19,
						"10": -18,
						"11": -17,
						"12": 8,
						"13": 9,
						"14": 10,
						"15": 11,
						"16": -23,
						"17": -22,
						"18": -21,
						"19": -20,
						"20": 8,
						"21": 9,
						"22": 10,
						"23": 11,
						"24": 0,
						"25": 1,
						"26": 2,
						"27": 3,
						"28": 21,
						"29": 22,
						"30": 23,
						"31": 24,
						"32": -23,
						"33": -22,
						"34": -21,
						"35": -20,
						"36": 0,
						"37": 1,
						"38": 2,
						"39": 3,
						"40": -7,
						"41": -6,
						"42": -5,
						"43": -4,
						"44": 21,
						"45": 22,
						"46": 23,
						"47": 24,
						"48": -8,
						"49": -7,
						"50": -6,
						"51": -5,
						"52": -20,
						"53": -19,
						"54": -18,
						"55": -17,
						"56": 16,
						"57": 17,
						"58": 18,
						"59": 19,
						"60": 21,
						"61": 22,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Fire Lead",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "distortion", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 11.3137,
						},
					],
					eqSubFilters1: [],
					effects: ["granular", "distortion", "bitcrusher", "chorus"],
					granular: 2,
					grainSize: 44,
					grainAmounts: 3,
					grainRange: 37,
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0.075,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 23,
						"2": 22,
						"3": 21,
						"4": 20,
						"5": 19,
						"6": 19,
						"7": 18,
						"8": 17,
						"9": 16,
						"10": 16,
						"11": 15,
						"12": 14,
						"13": 14,
						"14": 13,
						"15": 12,
						"16": 11,
						"17": 11,
						"18": 10,
						"19": 9,
						"20": 8,
						"21": 7,
						"22": 7,
						"23": 6,
						"24": 6,
						"25": 5,
						"26": 5,
						"27": 4,
						"28": 3,
						"29": 3,
						"30": 2,
						"31": 24,
						"32": -1,
						"33": -2,
						"34": -3,
						"35": -3,
						"36": -4,
						"37": -5,
						"38": -6,
						"39": -6,
						"40": -7,
						"41": -8,
						"42": -8,
						"43": -9,
						"44": -10,
						"45": -11,
						"46": -11,
						"47": -12,
						"48": -13,
						"49": -13,
						"50": -14,
						"51": -14,
						"52": -15,
						"53": -15,
						"54": -16,
						"55": -16,
						"56": -17,
						"57": -17,
						"58": -18,
						"59": -18,
						"60": -19,
						"61": -19,
						"62": -20,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Ice Lead",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "novelty", "idiophone"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "granular"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": 0,
						"3": 0,
						"4": -24,
						"5": -24,
						"6": 0,
						"7": 0,
						"8": -24,
						"9": -24,
						"10": 0,
						"11": 0,
						"12": -24,
						"13": -24,
						"14": 0,
						"15": 0,
						"16": -24,
						"17": -24,
						"18": 0,
						"19": 0,
						"20": -24,
						"21": -24,
						"22": 0,
						"23": 0,
						"24": -24,
						"25": -24,
						"26": 0,
						"27": 0,
						"28": -24,
						"29": -24,
						"30": 0,
						"31": 0,
						"32": 24,
						"33": 24,
						"34": 0,
						"35": 0,
						"36": 24,
						"37": 24,
						"38": 0,
						"39": 0,
						"40": 24,
						"41": 24,
						"42": 0,
						"43": 0,
						"44": 24,
						"45": 24,
						"46": 0,
						"47": 0,
						"48": 24,
						"49": 24,
						"50": 0,
						"51": 0,
						"52": 24,
						"53": 24,
						"54": 0,
						"55": 0,
						"56": 24,
						"57": 24,
						"58": 0,
						"59": 0,
						"60": 24,
						"61": 24,
						"62": 0,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "PSG Env Lead",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "featured", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "square",
					unison: "dirty",
					customChipWave: {
						"0": 1,
						"1": 8,
						"2": 7,
						"3": 5,
						"4": 4,
						"5": 2,
						"6": 9,
						"7": 8,
						"8": 6,
						"9": 4,
						"10": 2,
						"11": 0,
						"12": -1,
						"13": -7,
						"14": -5,
						"15": -7,
						"16": -9,
						"17": -10,
						"18": -12,
						"19": -14,
						"20": -16,
						"21": -17,
						"22": -19,
						"23": -21,
						"24": -24,
						"25": -14,
						"26": -7,
						"27": -7,
						"28": -8,
						"29": -9,
						"30": 13,
						"31": 11,
						"32": 8,
						"33": 8,
						"34": 8,
						"35": 8,
						"36": 7,
						"37": 7,
						"38": -7,
						"39": 24,
						"40": 24,
						"41": 22,
						"42": 20,
						"43": 18,
						"44": 16,
						"45": 14,
						"46": 12,
						"47": 11,
						"48": 9,
						"49": 7,
						"50": 5,
						"51": 3,
						"52": 1,
						"53": -1,
						"54": -1,
						"55": -2,
						"56": -2,
						"57": -3,
						"58": -3,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "PSG Env Lead 2",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "featured", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0.075,
					fadeOutTicks: 48,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 23,
						"1": 22,
						"2": 21,
						"3": 20,
						"4": 19,
						"5": 19,
						"6": 18,
						"7": 9,
						"8": 16,
						"9": 15,
						"10": 6,
						"11": -1,
						"12": 4,
						"13": 3,
						"14": 3,
						"15": 7,
						"16": 5,
						"17": 3,
						"18": -4,
						"19": 0,
						"20": -1,
						"21": -3,
						"22": 0,
						"23": -12,
						"24": -8,
						"25": -10,
						"26": -12,
						"27": -15,
						"28": -17,
						"29": -19,
						"30": -2,
						"31": -24,
						"32": -24,
						"33": -19,
						"34": -7,
						"35": -14,
						"36": -10,
						"37": -11,
						"38": -11,
						"39": -5,
						"40": -2,
						"41": 0,
						"42": 3,
						"43": -7,
						"44": -5,
						"45": 12,
						"46": 14,
						"47": 15,
						"48": 17,
						"49": 18,
						"50": 19,
						"51": 20,
						"52": 21,
						"53": 22,
						"54": 22,
						"55": 10,
						"56": 23,
						"57": 9,
						"58": 24,
						"59": 5,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Octave Pad",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 96,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 22,
						"2": 21,
						"3": 19,
						"4": 18,
						"5": 17,
						"6": 16,
						"7": 15,
						"8": 14,
						"9": 13,
						"10": 12,
						"11": 11,
						"12": 11,
						"13": 11,
						"14": 11,
						"15": 11,
						"16": 11,
						"17": 12,
						"18": 12,
						"19": 12,
						"20": 12,
						"21": 12,
						"22": 13,
						"23": 13,
						"24": 14,
						"25": 15,
						"26": 16,
						"27": 16,
						"28": 17,
						"29": 19,
						"30": 21,
						"31": 23,
						"32": 24,
						"33": 22,
						"34": 17,
						"35": 14,
						"36": 11,
						"37": 5,
						"38": 0,
						"39": -5,
						"40": -6,
						"41": -9,
						"42": -13,
						"43": -15,
						"44": -17,
						"45": -20,
						"46": -22,
						"47": -23,
						"48": -24,
						"49": -22,
						"50": -20,
						"51": -18,
						"52": -15,
						"53": -13,
						"54": -11,
						"55": -8,
						"56": -6,
						"57": -3,
						"58": 2,
						"59": 6,
						"60": 9,
						"61": 13,
						"62": 17,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Guitar Wave",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.125 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 1,
						"1": 3,
						"2": 5,
						"3": 5,
						"4": 6,
						"5": 6,
						"6": 6,
						"7": 7,
						"8": 7,
						"9": 7,
						"10": 7,
						"11": 8,
						"12": 8,
						"13": 7,
						"14": 7,
						"15": 6,
						"16": 6,
						"17": 5,
						"18": 5,
						"19": 3,
						"20": -1,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 1,
						"25": 1,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": -1,
						"30": 0,
						"31": 1,
						"32": 0,
						"33": 2,
						"34": 2,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": -1,
						"39": 1,
						"40": 1,
						"41": -2,
						"42": -3,
						"43": -3,
						"44": -4,
						"45": -4,
						"46": -5,
						"47": -5,
						"48": -6,
						"49": -6,
						"50": -5,
						"51": -5,
						"52": -5,
						"53": -5,
						"54": -4,
						"55": -4,
						"56": -4,
						"57": -4,
						"58": -3,
						"59": -3,
						"60": -3,
						"61": -1,
						"62": 1,
						"63": 2,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "BassGuitar Wave",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "picked", "guitar"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": 4,
						"2": 6,
						"3": 7,
						"4": 8,
						"5": 9,
						"6": 10,
						"7": 11,
						"8": 11,
						"9": 11,
						"10": 7,
						"11": 4,
						"12": 1,
						"13": -2,
						"14": -4,
						"15": -5,
						"16": -7,
						"17": -8,
						"18": -9,
						"19": -10,
						"20": -11,
						"21": -12,
						"22": -12,
						"23": -12,
						"24": -12,
						"25": -12,
						"26": -11,
						"27": -11,
						"28": -9,
						"29": -9,
						"30": -8,
						"31": -8,
						"32": -7,
						"33": -5,
						"34": -4,
						"35": -3,
						"36": -1,
						"37": 0,
						"38": 0,
						"39": 1,
						"40": 2,
						"41": 2,
						"42": 3,
						"43": 3,
						"44": 4,
						"45": 4,
						"46": 4,
						"47": 3,
						"48": 3,
						"49": 3,
						"50": 2,
						"51": 1,
						"52": 1,
						"53": -2,
						"54": -5,
						"55": -9,
						"56": -11,
						"57": -11,
						"58": -11,
						"59": -10,
						"60": -8,
						"61": -6,
						"62": -4,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Octave SawTri",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "distortion", "picked"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["bitcrusher"],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "recurve",
					customChipWave: {
						"0": 9,
						"1": 7,
						"2": 6,
						"3": 6,
						"4": 5,
						"5": 4,
						"6": 3,
						"7": 3,
						"8": 2,
						"9": 1,
						"10": 0,
						"11": -1,
						"12": -1,
						"13": -2,
						"14": -3,
						"15": -4,
						"16": -4,
						"17": 6,
						"18": 5,
						"19": 2,
						"20": 1,
						"21": -1,
						"22": -2,
						"23": -4,
						"24": -5,
						"25": -7,
						"26": -9,
						"27": -10,
						"28": -11,
						"29": -13,
						"30": -14,
						"31": -14,
						"32": 8,
						"33": 5,
						"34": 2,
						"35": 0,
						"36": -1,
						"37": -2,
						"38": -2,
						"39": -3,
						"40": -3,
						"41": -3,
						"42": -4,
						"43": -5,
						"44": -7,
						"45": -7,
						"46": -8,
						"47": -10,
						"48": -11,
						"49": -11,
						"50": -10,
						"51": -10,
						"52": -10,
						"53": -9,
						"54": -9,
						"55": -8,
						"56": -8,
						"57": -7,
						"58": -7,
						"59": -6,
						"60": -6,
						"61": -5,
						"62": -5,
						"63": -4,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Lead Pad",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "picked", "pad"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type", "vibrato"],
					transition: "continue",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.16,
					vibratoDelay: 10,
					vibratoSpeed: 5,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "square",
					unison: "spinner",
					customChipWave: {
						"0": -2,
						"1": -3,
						"2": -5,
						"3": -7,
						"4": -10,
						"5": -12,
						"6": -15,
						"7": -18,
						"8": -20,
						"9": -22,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -22,
						"24": -19,
						"25": -14,
						"26": -12,
						"27": -12,
						"28": -9,
						"29": -5,
						"30": -2,
						"31": 0,
						"32": 2,
						"33": 4,
						"34": 7,
						"35": 10,
						"36": 13,
						"37": 19,
						"38": 22,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 23,
						"56": 23,
						"57": 20,
						"58": 18,
						"59": 15,
						"60": 13,
						"61": 11,
						"62": 8,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "unison",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "vibratoDepth",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Chippy Piano",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "retro", "keys"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 1.4142,
						},
					],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.25 }],
					panDelay: 0,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "square",
					unison: "piano",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -23,
						"4": -23,
						"5": -23,
						"6": -22,
						"7": -22,
						"8": -22,
						"9": -21,
						"10": -21,
						"11": -21,
						"12": -21,
						"13": -20,
						"14": -20,
						"15": -20,
						"16": -19,
						"17": -19,
						"18": -17,
						"19": -16,
						"20": -14,
						"21": -13,
						"22": -11,
						"23": -10,
						"24": -8,
						"25": -7,
						"26": -5,
						"27": 0,
						"28": 4,
						"29": 9,
						"30": 13,
						"31": 7,
						"32": 4,
						"33": 2,
						"34": -1,
						"35": -4,
						"36": -7,
						"37": -8,
						"38": -9,
						"39": -10,
						"40": -12,
						"41": -13,
						"42": -15,
						"43": -16,
						"44": -16,
						"45": -17,
						"46": -19,
						"47": -19,
						"48": -20,
						"49": -20,
						"50": -21,
						"51": -21,
						"52": -22,
						"53": -22,
						"54": -23,
						"55": -23,
						"56": -23,
						"57": -23,
						"58": -23,
						"59": -24,
						"60": -24,
						"61": -24,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Piano Chimes",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "keys", "chimes"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1 2 3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 6.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Follin TriKick",
				generalMidi: false,
				tags: ["chip", "chipwave", "jayden256", "kick"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.3536 }],
					effects: ["transition type", "pitch shift", "detune"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					detuneCents: 200,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "T-Pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "picked", "bellows", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 4 }],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 2 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 2 }],
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "square",
					unison: "chorus",
					customChipWave: {
						"0": -14,
						"1": -14,
						"2": -13,
						"3": -13,
						"4": -13,
						"5": -12,
						"6": -12,
						"7": -12,
						"8": -12,
						"9": -11,
						"10": -11,
						"11": -11,
						"12": -11,
						"13": -11,
						"14": -11,
						"15": -10,
						"16": -10,
						"17": -9,
						"18": -9,
						"19": -9,
						"20": 24,
						"21": 23,
						"22": 22,
						"23": 22,
						"24": 21,
						"25": 21,
						"26": 21,
						"27": 20,
						"28": -22,
						"29": -22,
						"30": -24,
						"31": -24,
						"32": -14,
						"33": -14,
						"34": -14,
						"35": -14,
						"36": -13,
						"37": -13,
						"38": -12,
						"39": -11,
						"40": -10,
						"41": -10,
						"42": -9,
						"43": -9,
						"44": -9,
						"45": -8,
						"46": -8,
						"47": -8,
						"48": 24,
						"49": 23,
						"50": 23,
						"51": 22,
						"52": 22,
						"53": 22,
						"54": 22,
						"55": 21,
						"56": 21,
						"57": 20,
						"58": 20,
						"59": 19,
						"60": -22,
						"61": -22,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "unison",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "I-Pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 }],
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "square",
					unison: "askewed",
					customChipWave: {
						"0": -17,
						"1": -18,
						"2": -19,
						"3": -20,
						"4": -21,
						"5": -21,
						"6": -22,
						"7": -23,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": 4,
						"14": 4,
						"15": 5,
						"16": 5,
						"17": 5,
						"18": 6,
						"19": 8,
						"20": 9,
						"21": 10,
						"22": 11,
						"23": 11,
						"24": 11,
						"25": 14,
						"26": 16,
						"27": 18,
						"28": 18,
						"29": 18,
						"30": 19,
						"31": 20,
						"32": 21,
						"33": 22,
						"34": 23,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": -10,
						"53": -9,
						"54": -8,
						"55": -7,
						"56": -4,
						"57": -3,
						"58": -2,
						"59": 0,
						"60": 1,
						"61": 3,
						"62": 4,
						"63": 5,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "unison",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
						},
					],
				},
			},
			{
				name: "F-Sine",
				generalMidi: false,
				tags: ["chip", "customchip", "jayden256", "keys", "retro", "picked"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 }],
					effects: ["transition type", "detune"],
					transition: "continue",
					clicklessTransition: false,
					detuneCents: -8,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "lemmbox trapasquare",
					unison: "dirty",
					customChipWave: {
						"0": 24,
						"1": 23,
						"2": 22,
						"3": 21,
						"4": 20,
						"5": 19,
						"6": 18,
						"7": 17,
						"8": 14,
						"9": 13,
						"10": 12,
						"11": 11,
						"12": 10,
						"13": 9,
						"14": 8,
						"15": -2,
						"16": -3,
						"17": -4,
						"18": -5,
						"19": -6,
						"20": -7,
						"21": -8,
						"22": -14,
						"23": -15,
						"24": -16,
						"25": -17,
						"26": -18,
						"27": -19,
						"28": -20,
						"29": -21,
						"30": -22,
						"31": -24,
						"32": -24,
						"33": -22,
						"34": -21,
						"35": -20,
						"36": -19,
						"37": -18,
						"38": -17,
						"39": -16,
						"40": -15,
						"41": -14,
						"42": -13,
						"43": -8,
						"44": -7,
						"45": -6,
						"46": -5,
						"47": -4,
						"48": -3,
						"49": -2,
						"50": 8,
						"51": 9,
						"52": 10,
						"53": 11,
						"54": 12,
						"55": 13,
						"56": 14,
						"57": 18,
						"58": 19,
						"59": 20,
						"60": 21,
						"61": 22,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Solar Pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "pad"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 11,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 24,
					algorithm: "1←3 2←4",
					feedbackType: "4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 12, waveform: "absine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Lunar Pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "jayden256", "picked", "pad"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1.4142 }],
					effects: ["chorus", "echo"],
					panDelay: 10,
					chorus: 43,
					echoSustain: 57,
					echoDelayBeats: 0.667,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "jayden256"], settings: {} },
		]),
	},
];
